// extracted by mini-css-extract-plugin
export default {"root":"CustomDragPreview_root__MeKlp","icon":"CustomDragPreview_icon__BQ6bb","label":"CustomDragPreview_label__xwKZ5"};